import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { File } from '../../../files/file.model';

export const LOGO_SCHEMA = Object.freeze({
  X: 0,
  Y: 0,
  HEIGHT: 0,
  WIDTH: 0,
  FILE: File,
});
const RECORD = generateSchema(LOGO_SCHEMA);
const KEYS: any = generateKeys(LOGO_SCHEMA);

export class Logo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.FILE,
        value: props.get(KEYS.FILE) ? new File(this.file) : null,
      },
    ]);

    return selfModel as Logo;
  }

  get x(): number {
    return this.get(KEYS.X);
  }

  get y(): number {
    return this.get(KEYS.Y);
  }

  get height(): number {
    return this.get(KEYS.HEIGHT);
  }

  get width(): number {
    return this.get(KEYS.WIDTH);
  }

  get file(): File {
    return this.get(KEYS.FILE);
  }
}
